import React from "react";
//components
import { Navbar } from "../../global/Navbar/navbar";
//import assets
import Stuff from "../../../assets/images/doctor-nurses.svg";
import { Btn } from "../../global/Buttons/btns";

const Header = ({ setViewDiagnosis }) => {
  return (
    <header className="header">
      <img src={Stuff} alt="doctors" className="header__image" />
      <div className="container">
        <Navbar active="home" setViewDiagnosis={setViewDiagnosis} />
        <div className="flex-col ">
          <h2 className="heading__primary mt--huge mb--large">
            The best skin <br /> diagnosis diseases
          </h2>
          <p className="paragraph width--40 pos--relative">
            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
            sint. Velit officia consequat duis enim velit mollit. Exercitation
            veniam consequat sunt nostrud amet.
          </p>

          <Arrow />
          <Btn value="Get started" action={() => {}} name="primary" />
        </div>
      </div>
    </header>
  );
};

export default Header;

const Arrow = () => {
  return (
    <svg
      width="132"
      height="132"
      viewBox="0 0 132 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="pos--abs arrow"
    >
      <path
        d="M25.8935 87.6214C42.6327 94.5081 60.979 97.1265 78.1444 89.14C93.6381 81.9311 101.289 67.4537 87.0241 54.2751C80.2714 48.0366 68.0949 45.1537 60.2479 51.0362C51.5058 57.5899 61.6335 67.7195 68.5671 69.8415C84.7614 74.798 104.444 67.0751 111.278 49.8226C119.371 29.3916 97.3176 24.4166 97.3349 24.5659"
        stroke="#F8F8F8"
        stroke-width="3"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M33.1672 106.428C33.2991 104.431 32.591 102.598 31.9783 100.733C29.9669 94.6098 25.8432 88.6577 20.0433 85.5339C27.0694 86.7822 36.6122 86.0348 41.5616 80.4015"
        stroke="#F8F8F8"
        stroke-width="3"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
